<template>
  <div class="rootContainer" :style="{backgroundImage:`url(${require('../../assets/index/'+backgroundbg)})`}" id="IDRootContainer">
    <div class="waiting-text"><img src="../../assets/index/clock_icon.png" alt=""> &nbsp;&nbsp;{{detailInfo.orderInfo.uiOrderStatusText}}</div>
    <div class="address" v-if="detailInfo.orderInfo.orderStatusText == '已付款'">

      <img class="address-img" src="../../assets/index/state_bg.png" alt="">
      <div class="address-name">
        <div class="name">您的订单已进入库房，准备发货</div>
        <div class="address-text">2020-02-02 14:00</div>

      </div>

    </div>
    <div class="address" v-if="detailInfo.orderInfo.orderStatusText == '已发货'" @click="navToLogistics">

      <img class="address-img" src="../../assets/index/state_bg.png" alt="">
      <div class="address-name">
        <div class="name">您的订单已发货</div>
        <div class="address-text">2020-02-02 14:00</div>

      </div>

    </div>
    <div class="address" v-if="detailInfo.orderInfo.orderStatusText == '已收货'">

      <img class="address-img" src="../../assets/index/state_bg.png" alt="">
      <div class="address-name">
        <div class="name">欢迎再次光临</div>

      </div>

    </div>
    <div class="address" v-if="detailInfo.orderInfo">

      <img class="address-img" src="../../assets/index/address_img.png" alt="">
      <div class="address-name">
        <div class="name">{{detailInfo.orderInfo.consignee}} {{detailInfo.orderInfo.mobile}} <span class="tag" v-if="detailInfo.orderInfo.isDefault">默认</span></div>
        <div class="address-text">{{detailInfo.orderInfo.address}}</div>

      </div>

    </div>
    <div class="headerpanel" v-if="detailInfo.orderInfo.orderStatusText == '待付款'">
      <div class="cell">订单时间：<span class="cell-text">{{detailInfo.orderInfo.addTime}}</span> </div>
      <div class="cell">订单编号：<span class="cell-text">{{detailInfo.orderInfo.orderSn}}</span> </div>
      <!-- <div class="toolbar">
        <van-row>
          <van-col span="12"> 实付：<span style="color: red">￥{{detailInfo.orderInfo.actualPrice}}</span></van-col>
          <van-col span="12" class="btClass">
            <van-button type="danger" size="mini" @click="deleteOrder" class="toolButton">删除订单</van-button>
          </van-col>
        </van-row>
      </div> -->
    </div>

    <div class="detailPanel">
      <van-row>
        <van-col class="cell2-1 cellbasic" span="12">商品信息</van-col>

      </van-row>

      <!--订单商品信息-->
      <goodscell class="goodsCell" :isShowBtn="(item.comment == 0 && detailInfo.orderInfo.handleOption.comment) ? true:false " :info="item" v-for="(item,index) in detailInfo.orderGoods" :key="index"></goodscell>
      <van-divider class="diver" v-if="detailInfo" />
      <div class="order-info-item spec-beetwn">
        <div class="order-text">商品合计</div>
        <div class="order-value">{{`￥${detailInfo.orderInfo.uigoodsPrice}`}}</div>
      </div>
      <div class="order-info-item  spec-beetwn">
        <div class="order-text">运费</div>
        <div class="order-value">{{`￥${detailInfo.orderInfo.uifreightPrice}`}}</div>
      </div>
      <div class="order-info-item spec-beetwn">
        <div class="order-text">优惠券</div>
        <div class="order-value">{{`￥${detailInfo.orderInfo.uicouponPrice}`}}</div>
      </div>
      <div class="order-info-item spec-beetwn" v-if="detailInfo.orderInfo.orderStatusText == '未付款'">
        <div class="order-text weight">还需支付</div>
        <div class="order-value price">{{`￥${detailInfo.orderInfo.uiactualPrice}`}}</div>
      </div>

    </div>
    <div class="detailPanel" v-if="detailInfo.orderInfo.orderStatusText != '未付款' && detailInfo.orderInfo.orderStatusText != '已取消(系统)'">
      <van-row>
        <van-col class="cell2-1 cellbasic" span="12">订单信息</van-col>
      </van-row>
      <van-divider class="diver" />
      <div class="order-info-item">
        <div class="order-text">订单编号</div>
        <div class="order-value">{{detailInfo.orderInfo.orderSn}}</div>
      </div>
      <div class="order-info-item">
        <div class="order-text">提交时间</div>
        <div class="order-value">{{detailInfo.orderInfo.addTime}}</div>
      </div>
      <div class="order-info-item">
        <div class="order-text">支付方式</div>
        <div class="order-value">{{detailInfo.orderInfo.payType == "zfb"?"支付宝":"微信"}}</div>
      </div>
      <div class="order-info-item">
        <div class="order-text">实付金额</div>
        <div class="order-value">{{detailInfo.orderInfo.actualPrice}}</div>
      </div>
      <div class="order-info-item">
        <div class="order-text">付款时间</div>
        <div class="order-value">{{detailInfo.orderInfo.payTime}}</div>
      </div>

    </div>
    <div class="detailPanel" v-if="detailInfo.orderInfo.message != ''">
      <van-row>
        <van-col class="cell2-1 cellbasic" span="12">备注信息</van-col>
      </van-row>
      <div class="cosignee-text">{{detailInfo.orderInfo.message}}</div>

    </div>
    <div class="btn-box-btn">
      <div v-if="detailInfo.orderInfo.handleOption.cancel" @click.stop="cancelOrder" class="btn nobg">取消订单</div>
      <div v-if="detailInfo.orderInfo.handleOption.pay" @click.stop="nowPayment" class="btn">立即付款</div>
      <div v-if="detailInfo.orderInfo.handleOption.delete" @click.stop="deleteOrder" class="btn nobg">删除订单</div>

      <div v-if="detailInfo.orderInfo.handleOption.confirm" @click.stop="confirmOrder" class="btn">确认收货</div>
      <!-- <div v-if="detailInfo.orderInfo.handleOption.comment" @click.stop="navToOrderGoods" class="btn">评价商品</div> -->
      <div v-if="detailInfo.orderInfo.handleOption.refund" @click.stop="refundOrder" class="btn nobg">申请退款</div>
    </div>

  </div>
</template>

<script>
import goodscell from "../../components/goodscell";
import valuecell from "../../components/valuecell";
import {
  orderDetail,
  orderDelete,
  orderCancel,
  orderRefund,
  orderConfirm,
} from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "myorderdetail",
  components: { goodscell, valuecell },
  data() {
    return {
      backgroundbg: "waiting_delivery.png",
      detailInfo: {
        orderInfo: {
          consignee: "", //收货人
          address: "", //地址
          addTime: "", //下单时间
          orderSn: "", //订单编号
          actualPrice: 0, //实付价格
          mobile: "", //联系电话
          orderStatusText: "", //订单状态
          goodsPrice: 0, //商品合计
          id: 0, //订单id
          freightPrice: 0, //运费
          handleOption: {
            cancel: true, //取消订单
            delete: false, //删除订单
            pay: true, //去支付
            comment: false, //评论
            confirm: false, //确认收货
            refund: false, //退款
            rebuy: false, //重新购买
          },
        },
        orderGoods: [
          {
            id: 0, //订单中的商品id
            orderId: 0, //订单id
            goodsId: 0, //商品id
            goodsName: "", //商品名称
            goodsSn: "", //商品编号
            productId: 0, //销售id
            number: 1, //数量
            price: 0, //商品价格
            specifications: [""], //规格
            picUrl: "", //图片
            comment: 0,
            addTime: "",
            updateTime: "",
            deleted: false,
          },
        ],
      },
    };
  },

  mounted() {
    document.getElementById("IDRootContainer").style.height =
      document.body.clientHeight - 60 + "px";
    orderDetail(this.$route.query.id).then((res) => {
      console.log(res);
      if (res.data.errno == 0) {
        this.detailInfo = res.data.data;
        this.detailInfo.orderInfo.uigoodsPrice = this.detailInfo.orderInfo.goodsPrice.toFixed(
          2
        );
        this.detailInfo.orderInfo.uifreightPrice = this.detailInfo.orderInfo.freightPrice.toFixed(
          2
        );
        this.detailInfo.orderInfo.uicouponPrice = this.detailInfo.orderInfo.couponPrice.toFixed(
          2
        );
        this.detailInfo.orderInfo.uiactualPrice = this.detailInfo.orderInfo.actualPrice.toFixed(
          2
        );
        let key = this.detailInfo.orderInfo.orderStatusText;
        switch (key) {
          case "已取消(系统)":
            this.backgroundbg = "transaction_close.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "已取消";
            break;
          case "未付款":
            this.backgroundbg = "waiting_pay.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "等待付款";

            break;
          case "已付款":
            this.backgroundbg = "waiting_delivery.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "等待发货";

            break;
          case "已发货":
            this.backgroundbg = "waiting_receipt.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "等待收货";

            break;
          case "已收货":
            this.backgroundbg = "not_evaluated.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "等待评价";

            break;
          case "交易完成":
            this.backgroundbg = "not_evaluated.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "交易完成";

            break;

          case "订单取消，退款中":
            this.backgroundbg = "not_evaluated.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "等待退款";

            break;
          case "已退款":
            this.backgroundbg = "not_evaluated.png";
            this.detailInfo.orderInfo.uiOrderStatusText = "交易关闭";

            break;
          default:
            this.backgroundbg = "transaction_close.png";

            break;
        }
      }
    });
  },
  methods: {
    nowPayment() {
      this.$router.push({
        path: "/type/payment",
        query: {
          orderId: this.detailInfo.orderInfo.id,
          price: this.detailInfo.orderInfo.actualPrice,
        },
      });
    },
    cancelOrder() {
      console.log(this.detailInfo.orderInfo.id);
      let data = {
        orderId: this.detailInfo.orderInfo.id,
      };
      Dialog.confirm({
        title: "提示",
        message: "确认取消该订单？",
      })
        .then(() => {
          // on confirm
          orderCancel(data).then((res) => {
            if (res.data.errno == 0) {
              Toast("取消成功");
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    confirmOrder() {
      let data = {
        orderId: this.detailInfo.orderInfo.id,
      };
      Dialog.confirm({
        title: "提示",
        message: "确认收货？",
      })
        .then(() => {
          // on confirm
          orderConfirm(data).then((res) => {
            if (res.data.errno == 0) {
              Toast("成功收货");
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    refundOrder() {
      let data = {
        orderId: this.detailInfo.orderInfo.id,
      };
      Dialog.confirm({
        title: "提示",
        message: "确认申请退款？",
      })
        .then(() => {
          // on confirm
          orderRefund(data).then((res) => {
            if (res.data.errno == 0) {
              // let refundData = {
              //   orderId: this.detailInfo.orderInfo.id,
              //   orderPrice: this.detailInfo.orderInfo.actualPrice
              // };
              // if (this.detailInfo.orderInfo.payType == "zfb") {
              // aliRefund(refundData).then(aliRes => {
              //   console.log(aliRes);
              // });
              //   Toast("取消成功");
              //   this.$router.go(-1);
              // } else {
              // wxRefund(refundData).then(aliRes => {
              //   console.log(aliRes);
              // });
              Toast("取消成功");
              this.$router.go(-1);
              // wxPay/wxRefund
              // }
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    navToOrderGoods() {
      // console.log(this);
      // this.$router.push({
      //   path: "/evaluate",
      //   query: {
      //     orderGoodsId: this.detailInfo.orderInfo.id
      //     // goodsId: this.$route.query.goodsId
      //   }
      // });
    },
    deleteOrder() {
      console.log(this);
      let data = {
        orderId: this.detailInfo.orderInfo.id,
      };
      Dialog.confirm({
        title: "提示",
        message: "确认删除该订单？",
      })
        .then(() => {
          // on confirm
          orderDelete(data).then((res) => {
            if (res.data.errno == 0) {
              Toast("删除成功");
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    navToLogistics() {
      this.$router.push({
        path: "/logistics",
        query: {
          id: this.detailInfo.orderInfo.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.rootContainer {
  width: 100%;
  background-size: 100% 13.6rem;
  background-position: 0 0;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-top: 4rem;
  overflow-y: scroll;
  background-color: #f4f4f4;
  padding-bottom: 6rem;
  .waiting-text {
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #424242;
    letter-spacing: 0;
    line-height: 20px;
    display: flex;
    align-items: center;
    padding-left: 2rem;
    box-sizing: border-box;
    margin-bottom: 4.1rem;
    img {
      height: 2.3rem;
      width: 2.3rem;
      margin-right: 0.3rem;
    }
  }
  .address {
    position: relative;
    box-shadow: 0 0.5rem 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    width: 95.2%;
    margin: 1rem auto;
    height: 8.4rem;
    box-sizing: border-box;
    padding-left: 1.69rem;
    padding-right: 1.69rem;
    display: flex;
    align-items: center;
    // line-height: 5rem;
    text-align: left;
    // background: url("../../assets/index/address_icon.png") left top no-repeat;
    background-size: 100% 0.6rem;
    background-color: #ffffff;
    justify-content: flex-start;

    .address-no {
      width: 100%;
      color: #999;
    }
    .address-img {
      height: 3.2rem;
      width: 3.2rem;
    }
    .address-name {
      display: inline-block;
      margin-right: 3rem;
      margin-left: 1.2rem;
      width: 62%;
      .name {
        font-family: PingFangSC-Regular;
        font-size: 1.4rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
        .tag {
          background-image: linear-gradient(90deg, #fde58b 0%, #f8d268 100%);
          border-radius: 2px;
          padding: 0.2rem 0.6rem;
          font-family: PingFangSC-Regular;
          font-size: 1rem;
          color: #78470c;
          letter-spacing: 0;
          line-height: 1rem;
        }
      }
      .address-text {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.6rem;
        margin-top: 0.8rem;
      }
    }
  }
  .headerpanel {
    padding: 1.8rem 0px 0.5rem 5%;
    width: 95%;
    box-sizing: border-box;
    text-align: left;
    background-color: white;
    margin: 0 auto;
    box-shadow: 0 0.5rem 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;

    .cell {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      margin-bottom: 1.2rem;
      .cell-text {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.4rem;
        color: #424242;
        letter-spacing: 0;
        text-align: right;
        line-height: 1.4rem;
      }
    }
    .toolbar {
      margin-top: 10px;
      line-height: 40px;
      height: 40px;
      border-top: solid 1px lightgray;
      .btClass {
        text-align: right;
        .toolButton {
          width: 70px;
          margin-right: 10px;
        }
      }
    }
  }
  .detailPanel {
    background-color: white;
    padding: 1.6rem 1.2rem;
    width: 95%;
    box-sizing: border-box;
    box-shadow: 0 0.5rem 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 1rem auto;
    .cosignee-text {
      font-size: 1.4rem;
      text-align: left;
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.6rem;
    }
    .cell2-1 {
      background-color: white;
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 1.6rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.6rem;
      margin-bottom: 1.6rem;
    }
    .cell2-2 {
      background-color: white;
      text-align: right;
    }
    .goodsCell {
      margin-bottom: 0.5rem;
      background-color: white;
    }
  }
  .order-info-item {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1.4rem;
    .order-text {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      width: 7rem;
      text-align: left;
    }
    .order-value {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      text-align: right;
      line-height: 1.6rem;
    }
    .weight {
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
    .price {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #fe5845;
      letter-spacing: 0;
      text-align: right;
      line-height: 1.6rem;
      opacity: 1;
    }
  }
  .spec-beetwn {
    justify-content: space-between;
  }
  .btn-box-btn {
    display: flex;
    padding: 0 1rem;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    box-sizing: border-box;
    background: #f4f4f4;
    width: 100%;
    height: 5rem;
    padding-top: 0.5rem;
    box-sizing: border-box;
    .btn {
      padding: 0 1rem;
      height: 3rem;
      line-height: 3rem;
      min-width: 8.8rem;
      text-align: center;
      border: 1px solid #e0e1e0;
      border-radius: 1.6rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #a8a8a8;
      letter-spacing: 0;
      text-align: center;
      line-height: 3rem;
      box-sizing: border-box;
    }
    .btn:last-child {
      background: #d6be93;
      border-radius: 1.6rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 3rem;
      margin-left: 1.2rem;
      border: 1px solid #e0e1e0;
    }
    .nobg {
      border: 1px solid #e0e1e0 !important;
      background: #fff !important;
      color: #a8a8a8 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/person/myorderdetail.vue